// @flow

export const DEFAULT_THUMBNAIL_SIZE = '170X170'
export const DOWNLOAD_POLLING_INTERVAL = 2000
export const FILE_CHECK_INTERVAL = 1000
